export default __webpack_public_path__ + "static/media/vahid-vali.cffdc85a.png";